import { render } from "./MusicCollection.vue?vue&type=template&id=01caa137"
import script from "./MusicCollection.vue?vue&type=script&lang=js"
export * from "./MusicCollection.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__